"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FormElementWrapper = _interopRequireDefault(require("../FormElementWrapper"));

var _DateInput = _interopRequireDefault(require("./DateInput"));

require("react-datepicker/dist/react-datepicker.css");

var _excluded = ["saveFormat", "viewFormat", "placeholder", "required", "plain", "label", "language", "meta", "input", "clearable", "hasOnWheel", "liveSaver", "tooltip", "hasTimePicker", "handleChangeValue", "disabled", "manual"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DatePicker = function DatePicker(props) {
  var saveFormat = props.saveFormat,
      viewFormat = props.viewFormat,
      placeholder = props.placeholder,
      required = props.required,
      plain = props.plain,
      label = props.label,
      language = props.language,
      meta = props.meta,
      input = props.input,
      clearable = props.clearable,
      hasOnWheel = props.hasOnWheel,
      liveSaver = props.liveSaver,
      tooltip = props.tooltip,
      hasTimePicker = props.hasTimePicker,
      handleChangeValue = props.handleChangeValue,
      disabled = props.disabled,
      manual = props.manual,
      rest = _objectWithoutProperties(props, _excluded);

  var value = input.value;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      dateValue = _useState2[0],
      setDateValue = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selected = _useState4[0],
      setSelected = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      calendar = _useState6[0],
      setCalendar = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      _useState8 = _slicedToArray(_useState7, 2),
      blurAction = _useState8[0],
      setBlurAction = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      fromCalendar = _useState10[0],
      setFromCalendar = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      inputFocuc = _useState12[0],
      setInputFocuc = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      touched = _useState14[0],
      setTouched = _useState14[1];

  var elementCls = (0, _classnames["default"])('datepicker', {
    disabled: disabled,
    // 'input-element__error': metaData && metaData.touched && metaData.error,
    plain: plain
  });

  var valueToForm = function valueToForm(val) {
    return val && val.isValid() && parseInt(val.format(saveFormat), 10);
  };

  var getTimeCaption = function getTimeCaption() {
    switch (language) {
      case 'ru':
        return 'Время';

      case 'uk':
        return 'Час';

      case 'en':
        return 'Time';

      default:
        return 'UNKNOWN';
    }
  };

  var handleBlur = function handleBlur() {
    setTouched(true);
    setInputFocuc(false);
  };

  var checkValid = function checkValid(val) {
    var momentVal = (0, _moment["default"])(val, viewFormat, true);
    return momentVal.isValid() ? valueToForm(momentVal) : val;
  };

  var handleChange = function handleChange(val) {
    var newDate = val.isValid ? valueToForm(val) : checkValid(val);
    setFromCalendar(val === '' || !!val.isValid);
    input.onChange(val === '' ? null : newDate);
    if (handleChangeValue) handleChangeValue(newDate);
  };

  var getCustomInput = function getCustomInput() {
    return /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
      manual: manual,
      fieldKey: input.name,
      onChangeRaw: handleChange,
      setBlurAction: setBlurAction,
      calendar: calendar,
      clearable: clearable,
      value: dateValue,
      inputFocuc: inputFocuc
    });
  };

  (0, _react.useEffect)(function () {
    var toFormat = typeof value === 'string' ? viewFormat : saveFormat;
    var momentVal = (0, _moment["default"])(value, toFormat, true);
    var valid = value === null || value === '' ? true : momentVal.isValid();
    var isOpen = !!calendar && calendar.isCalendarOpen();
    var focusTo = fromCalendar && !isOpen;
    setBlurAction(valid);
    setInputFocuc(focusTo);
    setSelected(momentVal.isValid() ? momentVal : null);
    setDateValue(momentVal.isValid() ? momentVal.format(viewFormat) : value);
  }, [value]);
  return /*#__PURE__*/_react["default"].createElement(_FormElementWrapper["default"], {
    className: elementCls,
    tooltip: tooltip,
    meta: meta,
    touched: touched,
    hasOnWheel: hasOnWheel,
    label: label,
    liveSaver: liveSaver,
    blurAction: blurAction,
    required: required
  }, /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], _extends({}, input, rest, {
    value: dateValue,
    locale: language,
    title: dateValue,
    selected: selected,
    className: "input-field",
    showTimeSelect: hasTimePicker // showTimeSelectOnly={showTimeSelect}
    ,
    popperClassName: "datepicker-popper datepicker-portal",
    popperPlacement: "bottom-end",
    calendarClassName: "calendar",
    dateFormat: viewFormat,
    timeCaption: getTimeCaption(),
    timeFormat: "HH.mm",
    placeholderText: placeholder,
    customInput: getCustomInput(),
    isClearable: false,
    onChange: handleChange,
    onBlur: handleBlur,
    autoComplete: "off",
    ref: function ref(node) {
      return setCalendar(node);
    }
  })));
};

var _default = DatePicker;
exports["default"] = _default;
DatePicker.defaultProps = {
  language: 'en',
  saveFormat: 'X',
  // Unix Timestamp
  viewFormat: 'DD/MM/YYYY HH:mm',
  // 31/12/2018 24:60
  hasTimePicker: true,
  input: null,
  meta: null,
  label: '',
  manual: true
};
DatePicker.propTypes = {
  placeholder: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  plain: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  hasOnWheel: _propTypes["default"].bool,
  tooltip: _propTypes["default"].string,
  language: _propTypes["default"].string,
  saveFormat: _propTypes["default"].string,
  viewFormat: _propTypes["default"].string,
  hasTimePicker: _propTypes["default"].bool,
  input: _propTypes["default"].object,
  meta: _propTypes["default"].object,
  label: _propTypes["default"].string,
  clearable: _propTypes["default"].bool,
  liveSaver: _propTypes["default"].object,
  handleChangeValue: _propTypes["default"].func,
  manual: _propTypes["default"].bool
};